export default __webpack_public_path__ + "static/hero-9-5764db2ffa04e8bdf281d1fc7fd18e8c.webp";